// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f1ccca5e5d2c39dde0280edb38d1474a9d752463/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};